import { useNavigate } from 'react-router-dom'
import EditableListPage from '../components/EditableListPage'
import { Button } from '../../shared/components/Button'
import { FaPen } from 'react-icons/fa'
import TableView from '../../shared/components/TableView'
import { useTranslation } from 'react-i18next'

const VolunteersAdmin = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const renderTable = items => {
        const columns = [
            { key: 'name', label: t('fields.volunteer.fields.name') },
            { key: 'email', label: t('fields.volunteer.fields.email') },
            { key: 'mobile_number', label: t('fields.volunteer.fields.mobile_number') },
            { key: 'date_of_birth', label: t('fields.volunteer.fields.date_of_birth') },
        ]

        const handleRowClick = item => {
            navigate(`/admin/auth/volunteers/${item.id}`)
        }

        return (
            <TableView
                data={items}
                columns={columns}
                onRowClick={handleRowClick}
                searchKeys={['name']}
                searchPlaceholder={t('search.name')}
            />
        )
    }

    return (
        <EditableListPage
            title={t('navigation_admin.get_involved.volunteers')}
            endpoint='admin/volunteers'
            renderTable={renderTable}
            view='table'
            rowLink='/admin/auth/volunteers'
            buttons={
                <Button size='medium' onClick={() => navigate('/admin/auth/volunteers/create')}>
                    <FaPen /> {t('status.create')}
                </Button>
            }
        />
    )
}

export default VolunteersAdmin
